import { render, staticRenderFns } from "./OrderArtworkUpload.vue?vue&type=template&id=634ceaa4&"
import script from "./OrderArtworkUpload.vue?vue&type=script&lang=js&"
export * from "./OrderArtworkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports